<template>
  <div class="modal fade" id="deleteConfirmationModal" tabindex="-1" aria-labelledby="deleteConfirmationModalLabel"
    aria-hidden="true" ref="modalElement">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <h5 class="modal-title" id="deleteConfirmationModalLabel">
            Remover
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center py-3">
          <p class="fs-5 mb-0">
            Deseja remover <strong>{{ itemLabel }}</strong>?
          </p>
        </div>
        <div class="modal-footer border-0 justify-content-center pb-4">
          <button type="button" class="btn btn-secondary px-4 me-2" data-bs-dismiss="modal" :disabled="loading">
            Não
          </button>
          <button type="button" class="btn btn-danger px-4" @click="$emit('confirm')" :disabled="loading">
            {{ loading ? '...' : 'Sim' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

export default {
  name: 'DeleteConfirmationModal',
  props: {
    itemLabel: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    hide() {
      const modal = bootstrap.Modal.getInstance(this.$refs.modalElement);
      if (modal) modal.hide();
    }
  }
};
</script>

<style scoped>
.modal-content {
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.btn {
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 600;
}
</style>
